const Colors = {
    text: 'rgb(66, 66, 66)',
    textLighter: 'rgba(0,0,0,.6)',
};

export default Colors;
